import React from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import NewsDetail from "./pages/NewsDetail";
import NewsList from "./pages/NewsList";
import ProductList from "./pages/ProductList";
import ProductDetail from "./pages/ProductDetail";
import Wishlist from "./pages/Wishlist";
import ScrollToTop from "./components/ScrollToTop";
import FloatingChatButton from "./components/FloatingChatButton";
import FloatingCallButton from "./components/FloatingCallButton";
import Manufacturing from "./pages/Manufacturing";


function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="flex flex-col min-h-screen">
                <Header/>

                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/manufacturing" element={<Manufacturing/>}/>

                    <Route path="/news" element={<NewsList/>}/>
                    <Route path="/news/:slug" element={<NewsDetail/>}/>

                    <Route path="/products" element={<ProductList />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                </Routes>
                <Footer/>
                <FloatingChatButton/>
                <FloatingCallButton/>
            </div>
        </Router>
    );
}

export default App;
